import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, isLastItem } from '@airtel/air-design-system';
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { FlatList, View } from 'react-native';
import { TypographyWidget } from '../../../typography-widget';
import { SchedulingCalendar } from '../scheduling-calendar';
import { SchedulingCarouselItem } from '../scheduling-carousel-item';
import { getSchedulingCarouselCardStyles } from './SchedulingCarouselCardStyles';
export var SchedulingCarouselCard = forwardRef((props, ref) => {
  var modalRef = useRef({});
  var carouselRef = useRef(null);
  useImperativeHandle(ref, () => ({
    modalRef: modalRef,
    carouselRef: carouselRef
  }));
  var carousel = props.carousel,
    title = props.title,
    showActionCta = props.showActionCta,
    actionCtaProps = props.actionCtaProps,
    selectedDate = props.selectedDate,
    visible = props.visible,
    onSelectCarousel = props.onSelectCarousel,
    onCalendarOpen = props.onCalendarOpen,
    changeSelectedDate = props.changeSelectedDate;
  var schedulingCarouselCardStyles = getSchedulingCarouselCardStyles();
  return _jsxs(Card, Object.assign({
    style: schedulingCarouselCardStyles.carouselContainer
  }, {
    children: [_jsxs(View, Object.assign({
      style: schedulingCarouselCardStyles.carouselHeaderContainer
    }, {
      children: [_jsx(TypographyWidget, {
        text: title,
        type: "title-single-line-md"
      }), !!showActionCta && _jsx(SchedulingCalendar, {
        ref: modalRef,
        visible: visible,
        selectedDate: selectedDate,
        actionCtaProps: actionCtaProps,
        changeSelectedDate: changeSelectedDate,
        onCalendarOpen: onCalendarOpen
      })]
    })), _jsx(FlatList, {
      ref: carouselRef,
      data: carousel,
      keyboardShouldPersistTaps: "handled",
      horizontal: true,
      renderItem: _ref => {
        var item = _ref.item,
          index = _ref.index;
        return _jsx(SchedulingCarouselItem, {
          carouselItem: item,
          carouselIndex: index,
          isLastItem: isLastItem(carousel, index),
          onSelectCarousel: onSelectCarousel
        }, "carousel-item-" + index);
      },
      showsHorizontalScrollIndicator: false,
      keyExtractor: (_, index) => "carousel_" + index
    })]
  }));
});